
/**
 * Format the purity string based on metal type
 */
export function formatPurity(metal: 'gold' | 'silver' | 'ORO' | 'ARGENTO', purity: string): string {
  const isGold = metal === 'gold' || metal === 'ORO';
  
  // First normalize the purity string to ensure consistent format
  const normalizedPurity = purity.replace(/\s+/g, ' ').trim();
  
  if (isGold) {
    // For gold, add KT if not already present
    return normalizedPurity.endsWith('KT') ? normalizedPurity : `${normalizedPurity}KT`;
  } else {
    // For silver, first check if it's 999/PURO before any other processing
    if (normalizedPurity === 'PURO' || normalizedPurity === '999' || normalizedPurity === '999‰') {
      return '999‰';
    }
    
    // For all other silver purities, ensure proper formatting with ‰ symbol
    // First remove any existing ‰ symbol to prevent duplication
    const cleanPurity = normalizedPurity.replace('‰', '').trim();
    return `${cleanPurity}‰`;
  }
}

/**
 * Normalize purity string for database queries
 * Ensures consistent format between UI and database
 */
export function normalizePurity(purity: string): string {
  return purity.replace(/\s+/g, '').trim();
}

/**
 * Get normalized purity for database queries
 * Handles special cases like PURO -> 999 for silver
 */
export function normalizePurityForDatabase(metal: 'gold' | 'silver' | 'ORO' | 'ARGENTO', purity: string): string {
  const isGold = metal === 'gold' || metal === 'ORO';
  let normalized = purity.replace(/\s+/g, '').trim();
  
  if (!isGold) {
    // Handle silver specific cases
    if (normalized === 'PURO') {
      return '999';
    }
    // Remove ‰ symbol if present
    normalized = normalized.replace('‰', '').trim();
  }
  
  return normalized;
}
